module.exports = "https://assets.niwcorp.com/_next/static/images/ImpDates-c5717cc42f159d772bd0085f61ec7fca.jpg";